import {
  NetworkError,
  deepCamelCase,
  deepSnakeCase,
  Select,
  searchQueryString,
  intoSnakeCase,
} from '../../../../fetchers/_helpers';
import { CommentFields, Comment } from '../../../../models/components/schemas/comment/Comment';

/**
 * This file was automatically generated by @gctl/openapi-fetchers
 * Do not modify this file, any changes will be destroyed when
 * the command is rerun.
 */

export type PostAlbumVideoCommentRepliesFields = readonly CommentFields[];

/** Options for POST /albums/{album_id}/videos/{video_id}/comments/{comment_id}/replies */
export type PostAlbumVideoCommentRepliesOptions<Paths extends readonly string[]> = Omit<
  RequestInit,
  'method' | 'body'
> & {
  baseUrl?: string;

  /** Available fields on the response type, application/vnd.vimeo.comment+json */
  select: Paths;
  where: {
    /**
     * The ID of the showcase.
     */
    albumId: number;
    /**
     * The ID of the video.
     */
    videoId: number;
    /**
     * The ID of the comment.
     */
    commentId: number;
  };

  /** Possible query parameters for /albums/{album_id}/videos/{video_id}/comments/{comment_id}/replies */
  query?: {
    /**
     * The hashed password of the password-protected video.
     */
    password?: string;
  };

  /** Data serialized to body for POST /albums/{album_id}/videos/{video_id}/comments/{comment_id}/replies */
  variables: {
    /**
     * The rich comment in JSON stringified form.
     * @example {"type":"doc","content":[{"type":"paragraph","content":[{"type":"text","text":"I love this!"}]}]}
     */

    richtext?: string;

    /**
     * The reply to the comment.
     * @example I love this!
     */

    text: string;
  };
};

/** Result type for POST /albums/{album_id}/videos/{video_id}/comments/{comment_id}/replies */
export type PostAlbumVideoCommentRepliesResult<Paths extends readonly string[]> = Select<
  Comment,
  Paths
>;

/**
 * Add a reply to a video comment
 * This method adds a reply to the specified video comment.
 */
export async function postAlbumVideoCommentReplies<
  Paths extends PostAlbumVideoCommentRepliesFields,
>({
  baseUrl,
  select,
  variables,
  where: { albumId, videoId, commentId },
  query,
  ...options
}: PostAlbumVideoCommentRepliesOptions<Paths>): Promise<PostAlbumVideoCommentRepliesResult<Paths>> {
  let res = await fetch(
    `${baseUrl}/albums/${albumId}/videos/${videoId}/comments/${commentId}/replies?${searchQueryString(
      query,
    )}&fields=${select.map(intoSnakeCase).join(',')}`,
    {
      ...options,
      method: 'POST',
      body: JSON.stringify(deepSnakeCase(variables)),
    },
  );

  if (!res.ok) {
    throw new NetworkError('A network error occurred', res.status, res);
  }

  if (res.status === 204) {
    return null as unknown as PostAlbumVideoCommentRepliesResult<Paths>;
  }

  if (!res.headers.get('content-type')?.match(/^application\/(.+)?json$/)) {
    throw new Error('Expected JSON response');
  }

  let json = await res.json();
  return deepCamelCase(json);
}
